export const ALL_EDITIONS_SENTINEL = '__ALL_EDITIONS__';
